import {
  SET_ACTIVE_ACCOUNT,
  OPEN_PHONE_CALL_MODAL,
  HANG_UP_CALL,
  LOAD_CHANNEL,
  RELOAD_CHANNELS_LIST,
  RELOAD_CHATS_LIST,
} from 'stores/types';

const initialState = {
  activeAccount: null
};

const channelDetail = ( state = initialState, action ) => {
  switch( action.type ) {
    case SET_ACTIVE_ACCOUNT:
      return {
        ...state,
        activeAccount: action.account
      };
    case OPEN_PHONE_CALL_MODAL:
      return {
        ...state,
        phoneCalling: action.phone,
        lastCall: new Date().valueOf()
      };
    case LOAD_CHANNEL:
      return {
        ...state,
        loadChannelId: action.id,
        loadChannelDate: new Date().valueOf(),
      };
    case RELOAD_CHANNELS_LIST:
      return {
        ...state,
        reloadChannelDate: new Date().valueOf(),
      };
    case RELOAD_CHATS_LIST:
      return {
        ...state,
        reloadChatDate: new Date().valueOf(),
      };
    case HANG_UP_CALL:
      return {
        ...state,
        phoneCalling: null,
      };
    default:
      return state;
  }
};

module.exports = channelDetail;



// WEBPACK FOOTER //
// ./stores/reducers/common/channelDetail.js